export default {
  beforeMount(el, binding) {
    el.escEvent = function (event) {
      let isEscape = false;
      if ('key' in event) {
        isEscape = event.key === 'Escape' || event.key === 'Esc';
      } else {
        isEscape = event.keyCode === 27;
      }
      if (isEscape) {
        el.dispatchEvent(new Event('esc'));
        if (typeof binding.value === 'function') {
          binding.value(event);
        }
      }
    };
    document.body.addEventListener('keydown', el.escEvent);
  },
  unmounted(el) {
    document.body.removeEventListener('keydown', el.escEvent);
  }
};
